import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const DownloaderOathADS = () => {
  const faqs = [
    {
      question: "What does the ‘Oath/Dec & ADS Downloader’ do ?",
      answer:
        "A: This feature allows you to instantly download filled Oath/Declaration and Application Data Sheet (ADS) documents. Along with these, JUNE also provides an Excel report showing document availability and inventor details linked to the corresponding application number.",
    },
    {
      question: "What inputs are required to use this feature ?",
      answer:
        "A: You only need to provide a valid application number. The system will fetch the relevant documents automatically.",
    },
    {
      question: "What is the output of this feature ?",
      answer:
        "A: The Oath/Dec and ADS documents in PDF format, along with an Excel report (.xlsx) containing document availability and inventor details.",
    },
    {
      question: "What if some documents are not available ?",
      answer:
        "A: If either the Oath/Dec or ADS is missing for the given application number, JUNE will still generate the Excel report, clearly indicating which documents are available and which are not.",
    },
    {
      question: "Can I download documents in bulk ?",
      answer:
        "A: Yes. The Oath/Dec & ADS Downloader supports bulk downloads for up to 10 application numbers in a single request.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default DownloaderOathADS;
